import React, { useEffect, useRef, useState } from 'react'
import images from '../../Utils/images'
import { eventsend } from '../../Config/analyticsFunctions';
import { useNavigate } from 'react-router-dom'
import colors from '../../Utils/colors';
import { 
    Box,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Tooltip,
    IconButton,
    Button,
    InputAdornment,
    Stepper,
    Step,
    StepLabel,
} from '@mui/material';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import CloseIcon from "@mui/icons-material/Close";
import CheerioButton from '../../Components/CheerioButton';
import { getRCSStatus, RCSonboarding,V2WorkflowS3Link } from '../../Services';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const HeaderWithInfo = ({ label, info }) => (
  <div className="d-flex align-items-center mb-1">
    <label className="fw-bold me-1">{label}</label>
    <Tooltip title={info} placement="right">
      <IconButton size="small" sx={{ p: 0 }}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </div>
);

const steps = [
  { key: "business", label: "Business Details" },
  { key: "brand", label: "Brand Details" },
  {
    key: "verification",
    label: "Business Verification (In Progress)",
    caption: "Usually takes around 36 to 48 hours",
  },
  { key: "channel", label: "Channel Status" },
];

const RCSIntegration = () => {

    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        category: "",
        website: "",
        address: "",
        brandName: "",
        brandLogo: "",
        brandColor: "",
    });
    const authtoken = useSelector((state) => state.main.auth_token);
    const localdata = useSelector((s) => s.main.localdata);
    const [currentScreen, setCurrentScreen] = useState('Business');
    const [logoPreview, setLogoPreview] = useState("");
    const [errors, setErrors] = useState({ logo: "", hex: "" });
    const [status, setStatus] = useState('');
    const activeIndex = steps.findIndex((s) => s.key === status);
    const fileInputRef = useRef(null);

    useEffect(()=>{
         checkRCSStatusAPICall();
    },[])

const submitRCSOnboarding = () => {
    const payload = {
        businessName: form.name,
        businessCategory: form.category,
        businessURL: form.website,
        businessAddress: form.address,
        brandName: form.brandName,
        brandLogo: form.brandLogo,
        brandColor: form.brandColor,
    };

    RCSonboarding(authtoken, payload)
        .then((res) => {
            if (res?.flag) {
                toast.success("RCS Onboarding submitted successfully",{ position: 'top-center' });
                navigate('/creator');
            } else {
                console.error("Failed to create RCS User", res?.message);
            }
        })
        .catch((err) => {
            console.error("Error in RCS onboarding:", err);
        });
};



    const checkRCSStatusAPICall = () => {
        let token = authtoken;
        getRCSStatus(token).then((res)=>{
            if(res?.flag){
                setStatus("pending")
                console.log("RCS Status",res?.data);
            }else{
                setStatus('')
            }
        })
    }

    const handleChange = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

    const validateHex = (v) => /^#?[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/.test(v); 

    const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = String(reader.result || "");
        resolve(dataUrl);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

    const getS3Link = async (file, file64) => {
        const data = {
        image: file64,
        type: file?.type?.split("/")[0],
        format: file?.type?.split("/")[1],
        };
        const res = await V2WorkflowS3Link(data, authtoken);
        if (!res?.data?.url) throw new Error("S3 link not returned");
        return res.data.url;
    };

    const handleLogo = async (file) => {
        if (!file) return;

        const typeOk = /image\/(png|jpeg)/.test(file.type);
        const sizeOk = file.size >= 20 * 1024 && file.size <= 2 * 1024 * 1024;
        if (!typeOk || !sizeOk) {
        setErrors((e) => ({
            ...e,
            logo: "Please upload a PNG/JPG between 20KB and 2MB.",
        }));
        setForm((f) => ({ ...f, brandLogo: "" }));
        setLogoPreview("");
        return;
        }

        try {
        setErrors((e) => ({ ...e, logo: "" }));
        const dataUrl = await fileToBase64(file);         // <- was fileToBase64
        const s3Url = await getS3Link(file, dataUrl);      // pass dataUrl (with prefix)
        setForm((f) => ({ ...f, brandLogo: s3Url }));      // save S3 URL only
        setLogoPreview(URL.createObjectURL(file));  
        } catch (err) {
        console.error("Logo upload failed:", err);
        setErrors((e) => ({ ...e, logo: "Failed to upload logo. Try again." }));
        setForm((f) => ({ ...f, brandLogo: "" }));
        setLogoPreview("");
        }
    };

    const onDrop = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const f = e.dataTransfer.files?.[0];
        if (f) await handleLogo(f);
    };

    const onBrowse = async (e) => {
        const f = e.target.files?.[0];
        if (f) await handleLogo(f);
    };

    const removeLogo = () => {
        if (logoPreview) URL.revokeObjectURL(logoPreview); // free object URL
        setLogoPreview("");
        setForm((f) => ({ ...f, brandLogo: "" }));         // clear S3 link from form
        setErrors((e) => ({ ...e, logo: "" }));
        if (fileInputRef.current) fileInputRef.current.value = ""; // allow re-selecting same file
    };

    const badUrl =
    form.website &&
    !/^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test(form.website.trim());

  return (
    <>
    <div className='w-100 h-100 br-primary Row' style={{flex:1,overflow:'hidden'}}>
        <div className='w-50 Column justify-content-start align-items-start h-100 verythinscrollnew' style={{overflow:'auto',paddingInline:24,paddingBlock:30,backgroundColor:colors.white01}}>
            <div className='Row justify-content-start w-100 mb-4'>
                <img 
                    src={images.BackArrowBlack} 
                    style={{
                        height:20,
                        width:20,
                        objectFit:'contain',
                        cursor:'pointer',
                        marginInlineEnd:10,
                    }} 
                    onClick={()=>{navigate('/creator')}}
                />
                <h3>
                    {`Dashboard > RCS-Rich Communication Service`}
                </h3>
            </div> 
            <div className='Column w-100 justify-content-center align-items-start' style={{flex:1}}>
                <div className="my-3">
                    <h3 className='mb-3' style={{fontWeight:500}}>
                        {'RCS-Rich Communication Service'}
                    </h3>
                    <p className='my-3'>
                        Connect with clients, boost sales, and enhance customer experience with Rich Media Messages
                    </p>

                    <h5 className="fw-medium my-3">About this Channel</h5>
                    <p className='my-3'>
                        RCS (Rich Communication Services) is the next generation of SMS, offering a
                        more interactive and branded messaging experience—like WhatsApp, but built
                        right into Android’s default Messages app or iOS 18+.
                    </p>
                    <p className='my-3'>With RCS, you can send:</p>
                    <ul className="list-unstyled ps-3 my-3">
                        <li>🌟 Branded messages with your logo and name</li>
                        <li>🖼️ Rich media like images, videos & carousels</li>
                        <li>🔘 Interactive buttons and quick replies</li>
                        <li>📍 Real-time updates with read receipts and link tracking</li>
                    </ul>

                    <h5 className="fw-medium my-3">Pre-requisites</h5>
                    <ol className="ps-3 my-3">
                        <li className="my-2">
                        <strong>Business Information</strong>
                        <ul className="ps-3">
                            <li>✅ Business Name (Brand Name)</li>
                            <li>✅ Business Category / Industry</li>
                            <li>✅ Business Website URL (must be active for verification)</li>
                            <li>✅ Registered Business Address</li>
                        </ul>
                        </li>
                        <li className='my-2'>
                        <strong>Branding Details</strong>
                        <ul className="ps-3">
                            <li>✅ Brand Display Name (visible as sender name)</li>
                            <li>✅ Brand Logo (Square image, JPG/PNG)</li>
                            <li>✅ Brand Accent Color (Hex code)</li>
                        </ul>
                        </li>
                    </ol>
                </div>
            </div>
            
        </div>
        <div className='w-50 h-100 Column justify-content-center' style={{overflow:'auto',paddingInline:20,paddingBlock:30,backgroundColor:colors.white02}}>
            <div className='Column justify-content-start align-items-start verythinscrollnew' style={{width:'70%',height:'auto',maxHeight:'80%',overflowY:'auto',backgroundColor:colors.white01,border:`1px solid ${colors.borderwhite}`,borderRadius:20,paddingBlock:24,paddingInline:24}}>
                {status == 'success' ? (
                    <>
                    <div className='Column w-100'>
                        <img 
                            src={images.CircleCheckGreen} 
                            style={{
                                height:160,
                                width:160,
                                objectFit:'contain',
                                marginBlock:24,
                            }}
                        />
                        <h3 className='my-3' style={{fontWeight:700}}>
                            {'Setup Completed'}
                        </h3>
                        <p className='my-3' style={{textAlign:'center'}}>
                            {'Your application has been submitted to our service provider for verification.'}
                        </p>
                        <p className='my-3' style={{textAlign:'center'}}>
                            {'The verification process typically takes between 36 to 48 hours to complete. You can monitor your progress by clicking on the same setup card again.'}
                        </p>
                    </div>
                    </>
                ): status && status !== 'success' ? (
                    <>
                    <h3 className='mb-3' style={{fontWeight:600}}>
                        {'RCS Application Progress'}
                    </h3>
                    <Stepper orientation="vertical" activeStep={activeIndex} className='my-3'>
                        {steps.map((step, index) => (
                        <Step key={step.key} completed={index < activeIndex} className="mb-1">
                            <StepLabel>
                            <div className="d-flex flex-column">
                                <p className={index === activeIndex ? "fw-semibold" : "fw-normal"}>
                                {step.label}
                                </p>
                                {step.caption && (
                                <p>
                                    {step.caption}
                                </p>
                                )}
                            </div>
                            </StepLabel>
                        </Step>
                        ))}
                    </Stepper>
                    <div className='mt-3 Row w-100 justify-content-start'>
                        <img 
                            src={images.InfoCircle} 
                            style={{height:20,width:20,objectFit:'contain',marginInlineEnd:16}}
                        />
                        <p style={{color:colors.black04}}>
                            {'For any assistance or queries. Please reach out to your account manager or contact support'}
                        </p>
                    </div>
                    </>
                ): !status && (
                    <>
                    {currentScreen == 'Business' && (
                        <>
                        <h3 className='mb-3' style={{fontWeight:600}}>
                            {'1. Please enter your business details'}
                        </h3>
                        <p>
                            {'Business details are required for the verification and registration of your business on RCS Channel'}
                        </p>

                        {/* Business Name */}
                        <div className='w-100 mt-2 mb-2'>       
                            <HeaderWithInfo 
                                label="Business Name"
                                info="Name of business in documents"
                            />
                            <TextField 
                                className='my-2'
                                fullWidth
                                size='small'
                                placeholder="Name of business in documents"
                                value={form.name}
                                onChange={handleChange("name")}
                            />
                        </div>

                        {/* Business Category */}
                        <div className='w-100 mt-2 mb-2'>
                            <HeaderWithInfo
                                label="Business Category"
                                info="Select a category"
                            />
                            <FormControl fullWidth>
                                <Select
                                    size='small' 
                                    className='my-2'
                                    displayEmpty
                                    value={form.category}
                                    onChange={handleChange("category")}
                                    renderValue={(v) =>
                                        v ? v : <span style={{ color: "#9e9e9e" }}>Select a category</span>
                                }
                                    >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="Retail">Retail</MenuItem>
                                    <MenuItem value="Services">Services</MenuItem>
                                    <MenuItem value="Technology">Technology</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        {/* Website URL */}
                        <div className='w-100 mt-2 mb-2'>
                            <HeaderWithInfo
                                label="Website URL"
                                info="Enter your business website URL"
                            />
                            <TextField 
                                size='small' 
                                className='my-2'
                                fullWidth
                                placeholder="https://example.com"
                                value={form.website}
                                onChange={handleChange("website")}
                            />
                        </div>

                        {/* Address */}
                        <div className='w-100 mt-2 mb-2'>
                            <HeaderWithInfo
                                label="Enter your business’s registered physical address"
                                info="Address as per documents"
                            />
                            <TextField
                                size='small' 
                                className='my-2'
                                fullWidth
                                multiline
                                minRows={2}
                                placeholder="Address in documents"
                                value={form.address}
                                onChange={handleChange("address")}
                            />
                        </div>
                        </>
                    )} 
                    {currentScreen == 'Brand' && (
                        <>
                        <h3 className='mb-3' style={{fontWeight:600}}>
                            {'2. Please enter your brand details'}
                        </h3>
                        <p>
                            {'Brand Details are what your customers will see on their devices.'}
                        </p>

                        {/* Brand Name*/}
                        <div className='w-100 mt-2 mb-2'>
                            <HeaderWithInfo 
                                label="Brand Name" 
                                info="Your public-facing brand name" 
                            />
                            <TextField 
                                className='my-2'
                                fullWidth 
                                size='small'
                                placeholder="Cheerio AI"
                                value={form.brandName}
                                onChange={handleChange("brandName")}
                            />       
                        </div>

                        {/* Brand Logo */}
                        <div className='w-100 mt-2 mb-2'> 
                            <HeaderWithInfo 
                                label="Brand Logo" 
                                info="PNG or JPG only, 20KB–2MB" 
                            />
                            <div
                                onDrop={onDrop}
                                onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                onClick={() => fileInputRef.current?.click()}
                                className="w-100 d-flex flex-column align-items-center justify-content-center"
                                style={{
                                    border: "2px dashed #d0d0d0",
                                    borderRadius: "12px",
                                    padding: "1.25rem",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#fafafa",
                                    position: "relative",              // ← NEW
                                }}
                            >
                                {/* Show remove button only when a logo is present */}
                                {(logoPreview || form.brandLogo) && (
                                    <Tooltip title="Remove logo">
                                    <IconButton
                                        aria-label="Remove logo"
                                        size="small"
                                        onClick={(e) => { e.stopPropagation(); removeLogo(); }}
                                        style={{
                                        position: "absolute",
                                        top: 6,
                                        right: 6,
                                        background: "rgba(255,255,255,0.9)",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                                        }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                    </Tooltip>
                                )}

                                {logoPreview ? (
                                    <img
                                    src={logoPreview}
                                    alt="logo preview"
                                    style={{ maxHeight: 140, borderRadius: 8, maxWidth: "100%" }}
                                    />
                                ) : (
                                    <>
                                    <ImageOutlinedIcon style={{ fontSize: 42, marginBottom: 6 }} />
                                    <p className="mb-0">Drag or drop Image here</p>
                                    <small className="text-muted">(20kb–2Mb, only png or jpg image)</small>
                                    <div className="mt-2">
                                        <Button variant="outlined" size="small">Browse</Button>
                                    </div>
                                    </>
                                )}

                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    hidden
                                    onChange={onBrowse}
                                />
                                </div>
                            {errors.logo && <p className="text-danger small mt-1">{errors.logo}</p>}
                        </div>

                        {/* Brand Color */}
                        <div className='w-100 mt-2 mb-2'>    
                            <HeaderWithInfo 
                                label="Brand Color (HEX Code)" 
                                info="Your primary brand color in HEX" 
                            />
                            <TextField
                                fullWidth 
                                className='my-2'
                                placeholder="#" 
                                size='small'
                                value={form.brandColor}
                                onChange={(e) => {
                                const v = e.target.value.trim();
                                setForm((f) => ({ ...f, brandColor: v }));
                                setErrors((e2) => ({
                                    ...e2,
                                    hex: v && !validateHex(v) ? "Enter a valid HEX code (e.g., #1a73e8)." : "",
                                }));
                                }}
                                InputProps={{
                                startAdornment:
                                    form.brandColor.startsWith("#") || !form.brandColor ? null : (
                                    <InputAdornment position="start">#</InputAdornment>
                                    ),
                                }}
                                error={!!errors.hex}
                                helperText={errors.hex || " "}
                            />      
                        </div>
                        </>
                    )}
                    <div className='w-100 mt-3 mb-3 Row' style={{columnGap:10}}>
                        <CheerioButton 
                            btnText={'Back'}
                            borderStyle={{width:'50%',borderColor:colors.primary03}} 
                            textStyle={{color:colors.primary03}} 
                            disabled={currentScreen == 'Business'} 
                            onclick={()=>setCurrentScreen('Business')}
                        />
                        <CheerioButton 
                            btnText={currentScreen == 'Business' ? 'Next' : 'Submit'} 
                            borderStyle={{width:'50%',borderColor:colors.primary03}} 
                            textStyle={{color:colors.white01}} 
                            backColor={colors.primary03} 
                            onclick={()=>{
                                if(currentScreen == 'Business'){
                                    setCurrentScreen('Brand');
                                    eventsend("rcs_banner_clicked", {
                                    business_name: form.name,
                                     category: form.category,
                                    website_url: form.website,
                                     timestamp: new Date().toISOString(),
                                     account_id: localdata?._id,
                            });
                                }else{
                                       eventsend("rcs_brand_submitted", {
                                         brand_name: form.brandName,
                                        brand_logo_uploaded: !!form.brandLogo,   
                                         brand_color: form.brandColor,
                                         timestamp: new Date().toISOString(),
                                        account_id: localdata?._id,
                                            });
                                        submitRCSOnboarding();
                                }
                            }}
                        />
                    </div>
                    </>  
                )}
            </div>
        </div>
        
    </div>
    </>
  )
}

export default RCSIntegration